import getCurrentEntity from "./getCurrentEntity";

/**
 * @param {EditorState} editorState
 * @param {String}      entityType
 */
export default function isSelectingEntity(editorState, entityType) {
  const maybeCurrentEntity = getCurrentEntity(editorState);
  return maybeCurrentEntity ? maybeCurrentEntity.getType() === entityType : false;
}
